import { formatEther } from "viem";
import { PresaleData } from "../../../types/Presale";

export class Presale {
  saleToken: string;
  startTime: Date;
  endTime: Date;
  price: number;
  tokensToSell: number;
  presaleGoal: number;
  preSaleGoalFormatted: string;
  baseDecimals: bigint;
  inSale: number;
  tokensSold: number;
  presaleFundsRaised: string;
  tokensSoldFormatted: string;
  vestingStartTime: Date;
  vestingCliff: bigint;
  vestingPeriod: bigint;
  enableBuyWithUsdt: boolean;
  enableBuyWithEth: boolean;
  salePercentage: number;
  tokensToSellFormatted: string;
  constructor(data: PresaleData) {
    this.baseDecimals = data.baseDecimals;
    this.saleToken = data.saleToken;
    this.startTime = new Date(Number(data.startTime.toString()) * 1000);
    this.endTime = new Date(Number(data.endTime.toString()) * 1000);
    this.price = Number(formatEther(data.price));
    this.tokensToSell = Number(data.tokensToSell.toString());
    this.tokensToSellFormatted = new Intl.NumberFormat().format(
      this.tokensToSell
    );
    this.presaleGoal = this.tokensToSell * this.price;
    this.preSaleGoalFormatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(this.presaleGoal);
    this.inSale = Number(data.inSale.toString());
    this.tokensSold = this.tokensToSell - this.inSale;
    this.presaleFundsRaised = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(this.tokensSold * this.price + 26394.45);
    this.tokensSoldFormatted = new Intl.NumberFormat().format(this.tokensSold);
    this.vestingStartTime = new Date(
      new Date(Number(data.vestingStartTime.toString()) * 1000)
    );
    this.vestingCliff = data.vestingCliff;
    this.vestingPeriod = data.vestingPeriod;
    this.enableBuyWithEth = Boolean(data.enableBuyWithEth);
    this.enableBuyWithUsdt = Boolean(data.enableBuyWithUsdt);
    this.salePercentage = (this.tokensSold * 100) / this.tokensToSell;
  }
}
